import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  userLogin,
  userLogout,
  userForceLogoutAll,
} from "../configs/WebService";

export const loginUserThunk = createAsyncThunk(
  "auth/loginUser",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        userLogin,
        { username, password },
        {
          withCredentials: true,
        },
      );
      sessionStorage.removeItem("globalJoyrideSessionClosed");
      sessionStorage.setItem("startJoyrideAfterLogin", "true");
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Invalid username or password";
      return rejectWithValue(message);
    }
  },
);
export const logoutUserThunk = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("userToken");
      // Call your Node.js logout API
      await axios.post(
        userLogout,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      // localStorage.removeItem("font_size");
      localStorage.removeItem("questionPaperTourCompleted");
      localStorage.removeItem("quizType");
      localStorage.removeItem("selected_class_id");
      localStorage.removeItem("selected_group_id");
      sessionStorage.removeItem("globalJoyrideSessionClosed");
      return true;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);
export const forceLogoutAllThunk = createAsyncThunk(
  "auth/forceLogoutAll",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      // Hits the API we created: DELETE FROM user_sessions WHERE user_id = ...
      const response = await axios.post(userForceLogoutAll, {
        username,
        password,
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to wipe sessions";
      return rejectWithValue(message);
    }
  },
);
